export const AUTH_COOKIE = 'auth'
export const TENANT_COOKIE = 'tenant'
export const USER_INFO_COOKIE = 'user-info'
export const MICROSOFT_HOME_ACCOUNT_COOKIE = '@microsoft:homeAccountId'
export const USERS_SUPER_ADMIN_EMAIL = [
  'pedro.venchiarutti@inventta.net',
  'vinicius.arantes@inventta.net',
  'jessica.hakime@inventta.net',
  'evelyn.monteiro@inventta.net',
  'patrick.louback@inventta.net',
]

export const SUPPORT_EMAIL = 'suporte@avanttinovacao.com.br'
export const REGEX_URL = /^(.*?)\.avantti/

export const DATA_TABLE_ITEMS_PER_PAGE = 10

export const LOGROCKET_SENSITIVE_FIELDS = [
  'password',
  'token',
  'accessToken',
  'refreshToken',
  'cpf',
  'cnpj',
]
export const LOGROCKET_SENSITIVE_ROUTES = [
  '/login',
  '/reset-password',
  '/verify-code',
  '/change-password',
  '/change-email',
]

export const ALLOWED_IDEA_STATUSES = [
  'Aguardando análise',
  'Aguardando triagem',
  'Avaliações concluídas',
  'Concluída',
  'Em avaliação',
  'Em execução',
  'Pausada',
  'Ajustes pendentes',
]
